import React from "react";
import IconAnalise from "../componentsStyled/icon/Iconanalise";
import { Box, Button, Modal } from "@mui/material";

interface ModalAnaliseProps {
  isOpen: boolean;
  children?: React.ReactNode;
  onRequestClose: () => void;
}

const ModalAnalise: React.FC<ModalAnaliseProps> = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onRequestClose}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: 1,
        width: 300,
        height: "fit-content",
        bgcolor: "#fff",
        boxShadow: 24,
        "& .MuiBackdrop-root": { backgroundColor: "transparent" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 10,
      }}>
      <Box>
        <IconAnalise width={60} />
        <Box marginY={2}>
          <p>
            Em <strong className="yellow">Análise!</strong>
          </p>
        </Box>

        <Box marginY={2}>
          <p>Seu pedido já chegou, a solicitação está em processo de análise. Aguarde por atualizações.</p>
        </Box>
        <Button onClick={onRequestClose}>Voltar</Button>
      </Box>
    </Modal>
  );
};

export default ModalAnalise;
